module.exports = __webpack_public_path__ + "img/language-none.031108e9.png";